import React, { useState } from "react";

export default function StepAcademic({ data, onUpdate, onNext }) {
  const [error, setError] = useState("");

  const validate = () => {
    if (
      !data.qualification ||
      !data.field ||
      !data.graduationYear ||
      !data.score
    ) {
      setError("Please complete all required academic details.");
      return false;
    }
    setError("");
    return true;
  };

  return (
    <div className="bg-white rounded-2xl p-8 shadow-lg">
      <h2 className="text-xl font-semibold text-primary mb-4">
        Academic Background
      </h2>

      <p className="text-sm text-primary-dark mb-6">
        Tell us about your education so we can assess eligibility accurately.
      </p>

      <div className="space-y-4">
        <select
          value={data.qualification}
          onChange={(e) => onUpdate({ qualification: e.target.value })}
          className="w-full px-4 py-3 border rounded-lg"
        >
          <option value="">Highest Qualification</option>
          <option value="Bachelors">Bachelor’s</option>
          <option value="Masters">Master’s</option>
          <option value="Diploma">Diploma</option>
        </select>

        <input
          type="text"
          placeholder="Field of Study"
          value={data.field}
          onChange={(e) => onUpdate({ field: e.target.value })}
          className="w-full px-4 py-3 border rounded-lg"
        />

        <input
          type="number"
          placeholder="Graduation Year"
          value={data.graduationYear}
          onChange={(e) => onUpdate({ graduationYear: e.target.value })}
          className="w-full px-4 py-3 border rounded-lg"
        />

        <input
          type="text"
          placeholder="CGPA / Percentage"
          value={data.score}
          onChange={(e) => onUpdate({ score: e.target.value })}
          className="w-full px-4 py-3 border rounded-lg"
        />
      </div>

      {error && <p className="text-red-500 text-xs mt-3">{error}</p>}

      <div className="flex justify-end mt-6">
        <button
          onClick={() => {
            if (validate()) onNext();
          }}
          className="px-6 py-3 bg-primary text-white rounded-lg text-sm font-medium"
        >
          Continue
        </button>
      </div>
    </div>
  );
}
